module.exports = __webpack_public_path__ + "img/PHONE.58f051ad.png";